import { PUBLIC_JOB_CREATE_ALERT_URL } from './const';
import { PublicJobCreateAlertRequestData, PublicJobCreateAlertResponseData } from './types';
import { POST } from '@packages/dataFetch';

export async function createAlert(data: PublicJobCreateAlertRequestData) {
	const response = await POST<PublicJobCreateAlertResponseData>(PUBLIC_JOB_CREATE_ALERT_URL, {
		data,
	});

	return response.data;
}
